module.exports = "../../../../platform/assets/pageMainIcon/ig-basic-archives-2.svg";